<script lang="ts" setup>
/**
 * UI-kit component
 * Category: Loaders
 * Name: LoaderSmartestMinds
 */
import type { LoaderSmartestMindsProps } from './interfaces'

defineOptions({
  name: 'LoaderSmartestMinds',
})

const {
  size = 'lg',
  view = 'brand',
} = defineProps<LoaderSmartestMindsProps>()
</script>

<template>
  <span
    :class="['loader-smartest-minds', `loader-smartest-minds--${size}`, `loader-smartest-minds--${view}`]"
    role="img"
    aria-label="Loading"
  >
    <span class="loader-smartest-minds__spinner" />
  </span>
</template>

<style lang="scss" scoped src="./_loader-smartest-minds.scss" />
